import React, { useState } from "react";
import {
    Form,
    Input,
    Button,
    Upload,
    message,
    Row,
    Col
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { createFeedback } from "../../http/feedbackAPI";

const { TextArea } = Input;

const FeedbackForm = ({ onSuccess, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);

    const onFinish = async (values) => {
        try {
            setLoading(true);

            const formData = new FormData();

            // Armenian
            formData.append("firstNameAM", values.firstNameAM || "");
            formData.append("lastNameAM", values.lastNameAM || "");
            formData.append("textAM", values.textAM || "");

            // English
            formData.append("firstNameEN", values.firstNameEN || "");
            formData.append("lastNameEN", values.lastNameEN || "");
            formData.append("textEN", values.textEN || "");

            // Russian
            formData.append("firstNameRU", values.firstNameRU || "");
            formData.append("lastNameRU", values.lastNameRU || "");
            formData.append("textRU", values.textRU || "");

            if (image) {
                formData.append("img_main", image);
            }

            const feedback = await createFeedback(formData);

            message.success("Feedback added successfully");

            if (onSuccess) {
                onSuccess(values);
            }

        } catch (e) {
            console.error(e);
            message.error("Failed to add feedback");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Անուն (Հայերեն)"
                        name="firstNameAM"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Ազգանուն (Հայերեն)"
                        name="lastNameAM"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                label="Տեքստ (Հայերեն)"
                name="textAM"
                rules={[{ required: true }]}
            >
                <TextArea rows={4} />
            </Form.Item>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Անուն (Անգլերեն)"
                        name="firstNameEN"
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Ազգանուն (Անգլերեն)"
                        name="lastNameEN"
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                label="Տեքստ (Անգլերեն)"
                name="textEN"
            >
                <TextArea rows={4} />
            </Form.Item>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Անուն ( Ռուսերեն)"
                        name="firstNameRU"
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Ազգանուն ( Ռուսերեն)"
                        name="lastNameRU"
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                label="Տեքստ (Ռուսերեն)"
                name="textRU"
            >
                <TextArea rows={4} />
            </Form.Item>

            <Form.Item label="Նկար">
                <Upload
                    beforeUpload={(file) => {
                        setImage(file);
                        return false;
                    }}
                    maxCount={1}
                >
                    <Button icon={<UploadOutlined />}>
                        Բեռնել Նկար
                    </Button>
                </Upload>
            </Form.Item>

            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end"
                }}
            >
                <Button onClick={onClose}>
                    Չեղարկել
                </Button>

                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                >
                    Պահպանել
                </Button>
            </div>
        </Form>
    );
};

export default FeedbackForm;